import React from 'react';
import ComplianceRuleEditorSection from '../../../sections/AdminDashboard/ComplianceRulebook/ComplianceRuleEditor';

const ComplianceRuleEditor = () => {
  return <ComplianceRuleEditorSection />;
};

export default ComplianceRuleEditor;

